import React, { useEffect } from "react";

import {
	Dialog,
	DialogContent,
	DialogTitle,
	Box,
	Autocomplete,
	TextField,
	Chip,
	CircularProgress,
	DialogActions,
	Button,
	IconButton
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { AutocompleteWrapper } from "./styles";
import {
	useGetManageWeddingInvitationMemoriesEmailsQuery,
	useShareOwnerInvitationMemoryByEmailMutation
} from "../../../store/services/invitations/invitations.service";
import { toast } from "react-toastify";
import { notifyError } from "../../../utils/NotifyError";
import { IError } from "../../../utils/getErrorMessage";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ShareWeddingMemoriesByEmail = ({ open, onClose, id }: { open: boolean; onClose: () => void; id: string }) => {
	const [emails, setEmails] = React.useState<string[]>([]);
	const { data, isLoading } = useGetManageWeddingInvitationMemoriesEmailsQuery({ id });
	const [callShareByEmail, { isLoading: isSharingByEmail }] = useShareOwnerInvitationMemoryByEmailMutation();

	useEffect(() => {
		if (data) {
			setEmails(data?.emails);
		}
	}, [data]);

	const handleShare = () => {
		callShareByEmail({ _id: id as string, emails: emails }).then(({ data, error }) => {
			if (data) {
				toast.success("Album has been successfully shared.", { autoClose: 3000 });
				onClose && onClose();
			}
			if (error) {
				notifyError(error as IError);
			}
		});
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth={"xs"}
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">Share By Email</DialogTitle>
			<Box display="flex" justifyContent="flex-end" style={{ position: "absolute", right: "20px", top: "20px" }}>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</Box>
			<DialogContent>
				<AutocompleteWrapper mt={2}>
					{isLoading ? (
						<Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"30vh"}>
							<CircularProgress />
						</Box>
					) : (
						<Autocomplete
							multiple
							freeSolo
							options={[]} // no predefined options
							value={emails}
							onChange={(event, newValue) => {
								// normalize & validate
								const uniqueValidEmails = Array.from(
									new Set(newValue.map(e => e.trim()).filter(e => emailRegex.test(e)))
								);
								setEmails(uniqueValidEmails);
							}}
							renderTags={(value, getTagProps) => (
								<Box className={"chipsWrapper"}>
									{value.map((option, index) => (
										<Chip
											label={option}
											color={"primary"}
											size="small"
											{...getTagProps({ index })}
											key={`${option}-${index}`}
										/>
									))}
								</Box>
							)}
							renderInput={params => (
								<TextField
									{...params}
									label="Email addresses"
									placeholder="Type email and press Enter"
									multiline
									fullWidth
									minRows={2}
									maxRows={4}
								/>
							)}
						/>
					)}
				</AutocompleteWrapper>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button
					onClick={handleShare}
					disabled={isLoading || isSharingByEmail || !emails.length}
					loading={isSharingByEmail}
				>
					Share
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ShareWeddingMemoriesByEmail;
